// REACT ROUTER
import { Link, useNavigate } from "react-router-dom";

// HOOKS
import useClickOutside from "../../../CustomHooks/ClickOutside";
import React, { useContext, useState } from "react";

// ICONS , PICS , STYLES
import styles from "./MyProfile.module.scss";
import { BsGearWideConnected } from "react-icons/bs";
import ToggleThemeButton from "../../UiComponents/ToggleThemeBtn/ToggleThemeButton";
import NavContext from "../../../context/NavContext";

const MyProfile = () => {
  const [isProfileOpen, setIsProfileOpen] = useState(false);
  const { nav, setNav, setUserAuth, setLoading, adminProfile } =
    useContext(NavContext);
  const navigate = useNavigate();

  const domNode = useClickOutside(() => {
    setIsProfileOpen(false);
  });

  const logout = () => {
    localStorage.removeItem("jwt");
    localStorage.removeItem("isLoggedIn");
    setNav(!nav); // hidden side bar
    setUserAuth(false);
    navigate("/");
  };

  return (
    <div ref={domNode} className={styles.container}>
      {/* Gear Icon - open/close menu on click */}
      <BsGearWideConnected
  className={`${styles.settingIcon} ${isProfileOpen ? styles.active : ""}`}
  onClick={() => setIsProfileOpen((prev) => !prev)}
/>


      {/* AVATAR/SETTINGS SUBMENU */}
      <div
        className={`${styles.menu} ${isProfileOpen ? styles.menu_active : ""}`}
      >
        <div className={styles.info}>
          <span className={styles.role}>{adminProfile && adminProfile.display_name}</span>
        </div>
        <div className={styles.settings}>
          {/* <Link to="/private/mon-compte">Mon compte</Link> */}
          <Link onClick={logout} to="">
            Déconnexion
          </Link>
        </div>
      </div>
    </div>
  );
};

export default MyProfile;
